import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadToken, loadGuestToken } from './auth/authSlice';
import { selectIsLoggedIn } from './auth/authSlice';
import HomeMap from './pages/HomeMap';
import Referral from './pages/Referral';
import MyGames from './pages/MyGames';
import Games from './pages/Games';
import Contacts from './pages/Contacts';
import StartGame from './pages/StartGame';
import GameSteps from './steps/GameSteps';
import GameTeamSteps from './teams/GameTeamSteps';
import GetCoupon from './coupons/GetCoupon';
import GetGiftVoucher from './coupons/GetGiftVoucher';
import WarningScreen from './steps/WarningScreen';
import GameOverview from './steps/GameOverview';
import Login from './pages/Login';
import AuthLogin from './auth/AuthLogin';
import Register from './pages/Register';
import WaitingScreen from './teams/WaitingScreen';
import JoinGame from './teams/JoinGame';
import Success from './payment/Success';
import GameDetailsView from './containers/GameDetailsView';
import TermsAndConditions from './pages/TermsAndConditions';
import AuthContainer from './auth/AuthContainer';
import './App.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import ErrorPage from './ErrorPage';
import GenericErrorPage from './GenericErrorPage';
import { ErrorProvider } from './ErrorContext';
import SurveyComponent from './SurveyComponent';
import { GoogleOAuthProvider } from "@react-oauth/google";
import TestingCompaing from './pages/TestingCompaing';

const clientId = "762212588533-q0s638b5s9511sg8kre8qublq8pj4eml.apps.googleusercontent.com";

function App() {
  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, ''); // Get current date in format YYYYMMDD
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const dispatch = useDispatch();
  const { t } = useTranslation();


  useEffect(() => {
    dispatch(loadToken());
    dispatch(loadGuestToken());
  }, [dispatch]);

  const reloadPage = (to) => {
    const currentPath = window.location.pathname;
    if (currentPath === to) {
      window.location.reload();
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
    <ErrorProvider>
      <Router>
        <nav className="navbar">
          <div className="navbar-left">
            <span className="app-title"></span> {/* Optional App Title */}
          </div>
          <div className="navbar-right">
            <ul>
              <li>
                <NavLink to="/" activeClassName="active" onClick={() => reloadPage('/')}>
                  {t('home')}
                </NavLink>
              </li>
              <li>
                <NavLink to="/games" activeClassName="active" onClick={() => reloadPage('/games')}>
                  {t('games')}
                </NavLink>
              </li>
              <li>
                <NavLink to="/start_game" activeClassName="active" onClick={() => reloadPage('/start_game')}>
                  {t('start_a_game')}
                </NavLink>
              </li>
              <li>
                <NavLink to="/join" activeClassName="active" onClick={() => reloadPage('/join')}>
                  {t('join_game')}
                </NavLink>
              </li>
              { <li>
                <NavLink to="/contacts" activeClassName="active" onClick={() => reloadPage('/contacts')}>
                  {t('contacts')}
                </NavLink>
              </li> }
              
              {isLoggedIn ? (
                <li>
                  <NavLink to="/mygames" activeClassName="active" onClick={() => reloadPage('/mygames')}>
                    {t('my_games')}
                  </NavLink>
                </li>
              ) : (
                <li>
                  <NavLink to="/login" activeClassName="active" onClick={() => reloadPage('/login')}>
                    {t('login')}
                  </NavLink>
                </li>
              )}
              <li>
                <div className="navbar-left">
                  <LanguageSwitcher /> {/* Include LanguageSwitcher component here */}
                </div>
              </li>
            </ul>
          </div>
        </nav>

        <div className="maincontent">
          <Routes>
            <Route path={`/gameDetails/:title`} element={<GameDetailsView />} />
            <Route path="/" element={<HomeMap />} />
            <Route path="/ref/:id" element={<Referral />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/games/*" element={<Games />} />
            <Route path="/start_game/" element={<StartGame />} />
            <Route path="/game-steps/" element={<GameSteps />} />
            <Route path="/game-team-steps/" element={<GameTeamSteps />} />
            <Route path="/game-overview" element={<GameOverview />} />
            <Route path="/warningscreen" element={<WarningScreen />} />
            <Route path="/waiting_screen" element={<WaitingScreen />} />
            <Route path="/get-coupon/" element={<GetCoupon />} />
            <Route path="/get-gift_voucher/" element={<GetGiftVoucher />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/join" element={<JoinGame />} />
            <Route path="/mygames" element={<MyGames />} />
            <Route path="/success" element={<Success />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path={`/${currentDate}_auth_login`} element={<AuthLogin />} />
            <Route path="/86sdk3fds97" element={<AuthContainer />} />
            <Route path="/error" component={GenericErrorPage} />
            <Route path="*" element={<ErrorPage />} />
            <Route path="/survey" element={<SurveyComponent />} />
            <Route path="/testing-compaing" element={<TestingCompaing />} />
          </Routes>
        </div>
      </Router>

    </ErrorProvider>
    </GoogleOAuthProvider>
  );
}

export default App;